// IE fix
if (!Object.values) {
  Object.values = o => Object.keys(o).map(k => o[k]);
}